import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Modal from '../../UniformComponents/Modal'
import CheckboxGroup from '../form/CheckboxGroup'
import { sortBy } from '../../utils/helpers'

@observer
class ComparisonModal extends Component {
    changeYears = ({ value }) => {
        const { dashStore } = this.props
        const { changeYears } = dashStore

        changeYears({ value: value.map((v) => ({ value: Number(v) })) })
    }

    changePeriods = ({ name }) => {
        const { dashStore } = this.props
        const { changeBenchmarkPeriod } = dashStore

        changeBenchmarkPeriod({ value: name })
    }

    changeBenchmarks = ({ value }) => {
        const { dashStore } = this.props
        const { changeBenchmarks } = dashStore

        changeBenchmarks({ value: value.map((v) => ({ value: v })) })
    }

    render() {
        const { dashStore, showComparisonModal, toggleComparisonModal } = this.props
        const {
            years,
            benchmarks,
            benchmarkLabels,
            benchmarkPeriods,
            benchmarkPeriod,
        } = dashStore
        return (
            <Modal show={showComparisonModal} onClose={toggleComparisonModal}>
                <div className="comparisonModal">
                    <div className="benchmarks">
                        <CheckboxGroup
                            name="benchmarks"
                            label={i18n.t('dashboard.benchmarksTitle')}
                            options={sortBy(
                                Array.from(benchmarks)
                                    .map(([y]) => ({ label: benchmarkLabels[y], value: y })),
                                'value',
                            )}
                            defaultChecked={Array.from(benchmarks)
                                .filter((a) => !!a[1])
                                .map(([y]) => (y))}
                            onBlur={this.changeBenchmarks}
                            returnValueUnchanged
                        />
                    </div>
                    <div className="periods">
                        <CheckboxGroup
                            name="periods"
                            label={i18n.t('report_benchmark_period_label')}
                            options={benchmarkPeriods}
                            defaultChecked={benchmarkPeriod}
                            radioValue={benchmarkPeriod}
                            onBlur={this.changePeriods}
                            radio
                        />
                    </div>
                    <div className="years">
                        <CheckboxGroup
                            name="years"
                            label={i18n.t('powerpoint.labels.comparisonSurveyIds')}
                            options={sortBy(
                                Array.from(years)
                                    .map(([y]) => ({ label: y, value: y }))
                                    .filter((year) => (year.value >= 1900)),
                                'value', -1,
                            )}
                            defaultChecked={Array.from(years)
                                .filter((a) => !!a[1] && a[0] >= 1900)
                                .map(([y]) => y)}
                            onBlur={this.changeYears}
                            returnValueUnchanged
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ComparisonModal
